function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { anim } from 'modapp-utils';
import { RootElem } from 'modapp-base-component';
/**
 * A component rendering a list of items based on a collection
 */

var CollectionList =
/*#__PURE__*/
function (_RootElem) {
  _inherits(CollectionList, _RootElem);

  /**
   * Creates an instance of CollectionList
   * @param {Collection} collection Iterable list of items
   * @param {function} componentFactory  A factory function taking a collection item as argument, returning a component.
   * @param {object} [opt] Optional parameters.
   * @param {string} [opt.tagName] Tag name (eg. 'ul') for the element. Defaults to 'div'.
   * @param {string} [opt.className] Class name
   * @param {object} [opt.attributes] Key/value attributes object
   * @param {object} [opt.events] Key/value events object, where the key is the event name, and value is the callback.
   * @param {string} [opt.subTagName] Tag name (eg. 'li') for the element. Defaults to 'div'.
   * @param {string} [opt.subClassName] A factory function taking a collection item as argument, returning the className for the component.
   */
  function CollectionList(collection, componentFactory, opt) {
    var _this;

    _classCallCheck(this, CollectionList);

    opt = Object.assign({
      tagName: 'div'
    }, opt);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(CollectionList).call(this, opt.tagName, opt));
    _this.collection = null;
    _this.componentFactory = componentFactory;
    _this.subTagName = opt.subTagName || 'div';
    _this.subClassName = opt.subClassName || null;
    _this.components = null;
    _this.removedComponents = [];
    _this._add = _this._add.bind(_assertThisInitialized(_this));
    _this._remove = _this._remove.bind(_assertThisInitialized(_this));
    _this._rel = null; // Root elements node

    _this.setCollection(collection);

    return _this;
  }
  /**
   * Sets the collection.
   * If the component is rendered, the list will be rerendered with
   * the new collection, without any animation.
   * @param {?Collection} collection Iterable list of items
   * @returns {this}
   */


  _createClass(CollectionList, [{
    key: "setCollection",
    value: function setCollection(collection) {
      collection = collection || null;

      if (collection === this.collection) {
        return this;
      }

      if (!this._rel) {
        this.collection = collection;
        return this;
      }

      this._unrenderComponents();

      this.collection = collection;

      this._renderComponents();

      this._checkSync();

      return this;
    }
    /**
     * Gets the current collection
     * @returns {?Collection}
     */

  }, {
    key: "getCollection",
    value: function getCollection() {
      return this.collection;
    }
    /**
     * Get the component for a model by index
     * @param {number} idx Index if model
     * @returns {?Component} Model component, or null if the list isn't rendered, or if index is out of bounds
     */

  }, {
    key: "getComponent",
    value: function getComponent(idx) {
      if (!this._rel) {
        return null;
      }

      var cont = this.components[idx];
      return cont ? cont.component : null;
    }
    /**
     * Waits for the synchronization of the collection and component list to
     * ensure the collection models matches the rendered components.
     * Calling this method is necessary when calling getComponent after
     * adding/removing items from the collections.
     * Callback will never be called if the CollectionList isn't rendered, or
     * if it unrenders before it has been synchronized.
     * @param {function} callback Callback function called when collection and component list is synchronized.
     */

  }, {
    key: "sync",
    value: function sync(callback) {
      if (!this._rel) {
        return;
      }

      if (this._syncCallbacks) {
        this._syncCallbacks.push(callback);
      } else {
        this._syncCallbacks = [callback];
      }

      this._checkSync();
    }
  }, {
    key: "render",
    value: function render(el) {
      this._rel = _get(_getPrototypeOf(CollectionList.prototype), "render", this).call(this, el);

      this._renderComponents();

      return this._rel;
    }
  }, {
    key: "unrender",
    value: function unrender() {
      this._unrenderComponents();

      this._syncCallbacks = null;

      _get(_getPrototypeOf(CollectionList.prototype), "unrender", this).call(this);

      this._rel = null;
    }
  }, {
    key: "_checkSync",
    value: function _checkSync() {
      // No use checking syncronization if noone cares.
      if (!this._syncCallbacks) {
        return;
      }

      var i = 0,
          comp,
          len = this.components.length;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.collection[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var model = _step.value;

          // More models in the collection than components
          if (i === len) {
            return;
          }

          comp = this.components[i++];

          if (model !== comp.model) {
            return;
          }
        } // Do we have more components?

      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (i !== length) {
        return;
      } // We are in sync


      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this._syncCallbacks[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var cb = _step2.value;
          cb();
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this._syncCallbacks = null;
    }
  }, {
    key: "_setSubClassName",
    value: function _setSubClassName(item, li) {
      if (this.subClassName) {
        var className = this.subClassName(item);

        if (className) {
          li.className = className;
        }
      }
    }
  }, {
    key: "_renderComponents",
    value: function _renderComponents() {
      if (!this.collection) {
        return;
      }

      this.components = [];
      var idx = 0;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.collection[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var item = _step3.value;
          var component = this.componentFactory(item, idx);
          var li = document.createElement(this.subTagName);
          this.components.push({
            item: item,
            component: component,
            li: li
          });

          this._setSubClassName(item, li);

          this._rel.appendChild(li);

          if (component) {
            component.render(li);
          }

          idx++;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
            _iterator3["return"]();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this._setEventListener(true);
    }
  }, {
    key: "_unrenderComponents",
    value: function _unrenderComponents() {
      if (!this.collection) {
        return;
      }

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.components[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var cont = _step4.value;

          this._removeComponent(cont);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
            _iterator4["return"]();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      this.components = null;
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = this.removedComponents[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _cont = _step5.value;

          this._removeComponent(_cont);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5["return"] != null) {
            _iterator5["return"]();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      this.removedComponents = [];

      this._setEventListener(false);
    } // Callback when the collection have an add event

  }, {
    key: "_add",
    value: function _add(e) {
      // Assert component wasn't unrendered by another event handler
      if (!this._rel) {
        return;
      }

      var item = e.item,
          idx = e.idx;
      var component = this.componentFactory(item, idx);
      var li = document.createElement(this.subTagName);
      var cont = {
        model: item,
        component: component,
        li: li
      };
      this.components.splice(idx, 0, cont);

      this._setSubClassName(item, li);

      li.style.display = 'none'; // Append last?

      if (this.components.length - 1 === idx) {
        this._rel.appendChild(li);
      } else {
        this._rel.insertBefore(li, this.components[idx + 1].li);
      }

      if (component) {
        component.render(li);
      }

      cont.token = anim.slideVertical(li, true, {
        reset: true
      });

      this._checkSync();
    } // Callback when the collection have a remove event

  }, {
    key: "_remove",
    value: function _remove(e) {
      var _this2 = this;

      // Assert component wasn't unrendered by another event handler
      if (!this._rel) {
        return;
      }

      var cont = this.components[e.idx];
      this.components.splice(e.idx, 1);
      this.removedComponents.push(cont);
      anim.stop(cont.token);
      cont.token = anim.slideVertical(cont.li, false, {
        callback: function callback() {
          var idx = _this2.removedComponents.indexOf(cont);

          if (idx >= 0) {
            _this2.removedComponents.splice(idx, 1);

            _this2._removeComponent(cont);
          }
        }
      });

      this._checkSync();
    }
  }, {
    key: "_removeComponent",
    value: function _removeComponent(cont) {
      if (!this._rel) {
        return;
      }

      var token = cont.token,
          component = cont.component;
      anim.stop(token);

      if (component) {
        component.unrender();
      }

      this._rel.removeChild(cont.li);
    }
  }, {
    key: "_setEventListener",
    value: function _setEventListener(on) {
      if (this.collection && this.collection.on) {
        if (on) {
          this.collection.on('add', this._add);
          this.collection.on('remove', this._remove);
        } else {
          this.collection.off('add', this._add);
          this.collection.off('remove', this._remove);
        }
      }
    }
  }]);

  return CollectionList;
}(RootElem);

export default CollectionList;